<template>
  <div>
    <div class="card">
      <header class="card-header py-2"></header>
      <div class="card-content">
        <line-chart-free
          :height="300"
          :chart-data="chartData"
          :titulo="'Acesso à Rede Wi-Fi'"
        ></line-chart-free>
      </div>
    </div>
    <div style="right: 10px; top: 10px;margin-top: 12px">
      <!-- <label for="selPer">Período:</label>
      <select class="select-css"
        v-model.number="inner_settings.periodo"
        name="selPer"

      >
        <option value="8">8 h</option>
        <option value="12">12 h</option>
        <option value="24">24 h</option>
      </select>


      <select class="select-css"
        v-model.number="intervalo"
        name="selIn"

      >
        <option value="15">15 min</option>
        <option value="30">30 min</option>
        <option value="60">60 min</option>
      </select-->
    </div>
  </div>
</template>

<script>
import LineChartFree from "@/components/charts/LineChartFree";
var moment = require("moment");
export default {
  name: "OnlineLine",
  components: { LineChartFree },
  props: ["data", "settings", "segdata"],
  data() {
    return {
      inner_settings: { periodo: 24 },
      inner_data: { devices: [], online: [] },
      intervalo: 30,
      delta: 0,
      labels: [],
      rotated: false
    };
  },
  mounted() {
    this.inner_settings = this.settings;
    this.inner_data = this.segdata;
  },
  computed: {
    chartData() {
      var self = this;

      var newData = { labels: [], online: [], devices: [] };

      try {
        if (self.data[0]) {
          newData = segmentData(
            self.data,
            this.intervalo,
            "minute",
            self.data[0].datetime,
            self.data[self.data.length - 1].datetime
          );

          self.inner_data.devices = newData.devices;
          self.inner_data.online = newData.online;
        }
      } catch (exc) {}

      return {
        labels: newData.labels,
        datasets: [
          {
            label: "Conectados",
            borderWidth: 2,
            borderColor: "#f2476a",
            data: newData.devices,
            pointBackgroundColor: "#fff",
            lineTension: 0,
            pointRadius: 2
          },
          {
            label: "Online",
            borderColor: "#92a8d1",
            data: newData.online,
            borderWidth: 2,
            pointBackgroundColor: "#fff",
            lineTension: 0,
            pointRadius: 2
          }
        ]
      };
    }
  }
};

function segmentData(
  data,
  intervalValue,
  intervalType,
  datetimeStart,
  datetimeEnd
) {
  var dates = [];

  var currDate = moment(datetimeStart).startOf(intervalType);
  var lastDate = moment(datetimeEnd).startOf(intervalType);

  while (currDate.add(intervalValue, intervalType + "s").diff(lastDate) < 0) {
    dates.push(currDate.clone().toDate());
  }

  var online = [];
  var devices = [];
  var labels = [];

  var dtLast = dates[0];
  var initial = 0;

  dates.forEach(dtCurr => {
    var avg = {
      devices: 0,
      online: 0,
      datetime: moment(dtCurr).format("HH:mm")
    };
    var ct = 0;
    var found = false;

    for (var i = initial; i < data.length && !found; i++) {
      var currData = data[i];

      if (
        moment(currData.datetime).diff(dtCurr, intervalType + "s") >=
        intervalValue
      ) {
        found = true;
        initial = i;
      } else {
        avg.devices += currData.devices;
        avg.online += currData.online;
        ct++;
      }
    }

    if (ct != 0) {
      avg.devices = Math.ceil(avg.devices / ct);
      avg.online = Math.ceil(avg.online / ct);
    }

    online.push(avg.online);
    devices.push(avg.devices);
    labels.push(avg.datetime);
  });

  return {
    labels: labels,
    online: online,
    devices: devices
  };
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed|Titillium+Web");

span.subtitle {
  color: gray;
  text-transform: uppercase;
  font-size: medium;
  font-weight: 200;
}

div.root {
  padding: 0;
  margin: 2px;
  width: 100%;
  height: 140px;
  background-color: #ffffff;
  display: inline-block;
}

div.box-title {
  width: 112px;
  height: 25px;
  font-family: "Roboto Condensed", "Arial Narrow";
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
}

div.box-value {
  font-family: "Titillium Web", "Arial";
  font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: black;
}

div.box-footer {
  width: 146px;
  height: 20px;
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
}
div.small {
  font-size: x-small;
}

.trend-icon {
  margin-bottom: 8px !important;
}

div.circle {
  background: #1eeb2e;
  display: inline-block;
  margin: 0 0 2px 0;
  border-radius: 50%;
  height: 12px;
  width: 12px;
}
.v-card__text {
  padding-bottom: 0px;
  padding-left: 0px;
  padding-top: 40px;
  padding-right: 0px;
}

.card-content {
  padding: 0;
}
.select-css {
  display: inline-block;
  font-size: 12px;
  font-family: sans-serif;
  font-weight: 700;
  color: #fff;
  line-height: 1;
  padding: 0.6em 0.8em 0.5em 0.6em;
  width: 72px;
  max-width: 50%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.4em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: rgba(59, 153, 252, 0.7);
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #0077ff 0%, rgb(59, 153, 252) 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #fff;
  outline: none;
}
.select-css option {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/OnlineLine.vue